module.exports = __webpack_public_path__ + "img/1-1Q22H034094G.0ed8d4b7.png";